import { useState, useEffect } from 'react';
import { api } from '../ApiMapper/api';

export const useSubscription = () => {
  const [status, setStatus] = useState({
    isLoading: true,
    isActive: false,
    subscription: null,
    error: null
  });

  const checkSubscription = async () => {
    try {
      const response = await api.get('/api/subscriptions/status');
      setStatus({
        isLoading: false,
        isActive: response.data.isActive,
        subscription: response.data.subscription,
        error: null
      });
    } catch (error) {
      setStatus({
        isLoading: false,
        isActive: false,
        subscription: null,
        error: error.response?.data?.message || 'Failed to check subscription'
      });
    }
  };

  useEffect(() => {
    checkSubscription();
  }, []);

  return { ...status, refreshStatus: checkSubscription };
};